// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Material from '../renderer/Material';
import RenderTarget from '../renderer/pass/RenderTarget';
import Shader from '../renderer/Shader';
import RenderPass from '../renderer/pass/RenderPass';
import FullscreenPass from '../renderer/pass/FullscreenPass';
import Pass from '../renderer/pass/Pass';
import BlurPass from '../passpack/BlurPass';
import ShaderLibExtra from './ShaderLibExtra';

/**
 * Depth pass
 * @param renderList
 * @param outShader
 */
class DepthPass extends Pass {
  constructor(renderList, outShader) {
    super();
    this.depthPass = new RenderPass(renderList);
    const packDepthMaterial = new Material(ShaderLibExtra.depthPassPackDepth);
    this.depthPass.overrideMaterial = packDepthMaterial;

    this.blurTarget = new RenderTarget(256, 256);
    this.blurPass = new BlurPass({
      target: this.blurTarget,
    });

    const shader = outShader || ShaderLibExtra.depthPassUnpackDepth;
    this.outPass = new FullscreenPass(shader);
    this.outPass.useReadBuffer = false;
    // this.outPass.clear = true;

    const width = window.innerWidth || 1;
    const height = window.innerHeight || 1;
    this.depthTarget = new RenderTarget(width, height);

    this.enabled = true;
    this.clear = false;
    this.needsSwap = true;
  }

  render(renderer, writeBuffer, readBuffer, delta) {
    this.depthPass.render(renderer, null, this.depthTarget, delta);

    this.blurPass.render(renderer, writeBuffer, readBuffer, delta);

    this.outPass.material.setTexture(Shader.DEPTH_MAP, this.depthTarget);
    this.outPass.material.setTexture(Shader.DIFFUSE_MAP, readBuffer);
    this.outPass.material.setTexture('BLUR_MAP', this.blurTarget);
    this.outPass.render(renderer, writeBuffer, readBuffer, delta);
  }
}

export default DepthPass;
